import React, { ReactElement } from "react";
import { TableDataProps } from ".";

interface RowsProps {
  data: ReadonlyArray<TableDataProps>;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: (v: Record<string, any>) => void;
  rowTestID?: string;
}

const Rows: React.FC<RowsProps> = ({ data, onClick, rowTestID }: RowsProps): JSX.Element => {
  return (
    <>
      {
        data.map<ReactElement>((row, i) => {
          const fields = row.fields.map(({ key, className, labels, testID }) => {
            let field;

            if (Array.isArray(labels)) {
              field = (labels as string[]).map((label) => {
                return <span key={label}>{label}</span>;
              });
            } else {
              field = <span>{labels}</span>;
            }

            return (
              <td key={key} className={className} data-testid={testID}>
                {field}
              </td>
            );
          });

          // binds the click handler to each row
          let onClickBound;
          if (typeof onClick !== "undefined" && onClick !== null) {
            onClickBound = onClick.bind(undefined, row);
          }

          return (
            <tr key={i} className={row.className} onClick={onClickBound} data-testid={rowTestID + i}>
              {fields}
            </tr>
          );
        })}
    </>
  );
};

export default Rows;
